module.exports = __webpack_public_path__ + "img/workshops_map.24bd0ff2.png";